import { render, staticRenderFns } from "./Bio.vue?vue&type=template&id=d6f2a2b0&"
import script from "./Bio.vue?vue&type=script&lang=js&"
export * from "./Bio.vue?vue&type=script&lang=js&"
import style0 from "./Bio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
